export const UI_CONTROLS = [
    { label: "Textfält", value: 0 },
    { label: "Datumväljare", value: 1 },
    { label: "Kryssruta", value: 2 },
    { label: "Dropdown", value: 3 },
    { label: "Uppslag", value: 4 },
    { label: "Nummer", value: 5 },
    { label: "Decimal", value: 6 },
    { label: "Belopp", value: 7 },
];
